/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { useAppSelector } from '../../reducers';
import { getRootAppConfig } from '../../selectors/initiative';
import { getDefaultConfig } from '../../config/app-config';
import { AppConfig } from '../../types/app';

export const useAppConfig = (): AppConfig | undefined => {
  return useAppSelector(getRootAppConfig);
}

export const useAppSettings = (): AppConfig['settings'] => {
  const appConfig = useAppSelector(getRootAppConfig)
  if (appConfig) {
    return appConfig.settings
  }
  return getDefaultConfig().branding.ctlApp
}
